<template>
  <div id="app">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from "./components/layout/Header";

export default {
  name: "app",
  bilde1: require("./assets/Design/SjoLand.jpg"),
  components: {
    Header
  }
};
</script>


<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.4;
}

.btn {
  display: inline-block;
  border: none;
  background: #555;
  color: #fff;
  padding: 7px 20px;
  cursor: pointer;
}

.btn:hover {
  background: #666;
}

#app {
  background-image: url("./assets/Design/SjoLand.jpg");

  background-size: cover;
  opacity: 1;
  width: 100%;
  height: 800px;

  left: 0px;
  top: 0px;
  z-index: 0;
}
</style>
